var map = {
	"./de.ts": 225,
	"./en.ts": 226
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;


//////////////////
// WEBPACK FOOTER
// ./src/app/locales/translations ^\.\/.*\.ts$
// module id = 224
// module chunks = 0